import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    Spacer,
} from '@zillow/constellation';

const propTypes = {
    buttonText: PropTypes.string.isRequired,
    excelUrl: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

const defaultProps = {
    disabled: false,
};

// All excel links are currently external
// TODO: make links more flexible
function AsideAnalytics({ buttonText, excelUrl, disabled }) {
    return (
        <Spacer paddingBottom="md">
            <Button
                buttonType="primary"
                fluid={true}
                data-test="download-excel-button"
                disabled={disabled}
                onClick={() => window.open(excelUrl)}
            >
                {buttonText}
            </Button>
        </Spacer>
    );
}

AsideAnalytics.propTypes = propTypes;
AsideAnalytics.defaultProps = defaultProps;

export default AsideAnalytics;
